import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import MedicationIcon from "@mui/icons-material/Medication";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AssignmentIcon from "@mui/icons-material/Assignment";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

export const arr = [
  {
    id: "manage_appointments",
    name: "Appointment Management",
    path: "doctor/appointments",
    icon: (
      <QueuePlayNextIcon style={{ color: "white", transform: "scale(2)" }} />
    ),
  },
  {
    id: "register_patient",
    name: "Patient management",
    path: "register_patient",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "care_context",
    name: "Create & Link Visit Purpose",
    path: "care_context",
    icon: <MedicationIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "consent",
    name: "Longitudinal Data Access",
    path: "consent",
    icon: <TextSnippetIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "billing",
    name: "Billing and Invoice",
    path: "doctor/patient",
    icon: (
      <AdminPanelSettingsIcon
        style={{ color: "white", transform: "scale(2)" }}
      />
    ),
  },
  {
    id: "upload_report",
    name: "Upload Report",
    path: "upload_report",
    icon: <AssignmentIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "scan_qr",
    name: "QR",
    path: "scan_qr",
    icon: (
      <QrCodeScannerIcon style={{ color: "white", transform: "scale(2)" }} />
    ),
  },
  {
    id: "laboratories",
    name: "Lab service management",
    path: "laboratories",
    icon: (
      <AdminPanelSettingsIcon
        style={{ color: "white", transform: "scale(2)" }}
      />
    ),
  },
  {
    id: "manage_medicines",
    name: "Medicines management",
    path: "pharmacy-user",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "view_appointment",
    name: "Appointment management",
    path: "doctor/appointments",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "scan_share_records",
    name: "Scan & Share Records",
    path: "scan_share_records",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
];

const both = [
  // "manage_appointments",
  "register_patient",
  "care_context",
  "consent",
  "billing",
  "upload_report",
  "scan_qr",
  "scan_share_records",
];
const hiu = ["register_patient", "consent", "scan_share_records"];
const hip = [
  "register_patient",
  "care_context",
  "upload_report",
  "scan_qr",
  "scan_share_records",
];
const connector = ["consent"];

export const accessMapping = {
  "facility user": {
    "EHR/HMIS Service With ABDM Connector - HIU/HIP": [
      "manage_appointments",
      "register_patient",
      "care_context",
      "billing",
      "upload_report",
      "scan_qr",
      "scan_share_records",
    ],
    "EHR/HMIS Service Without ABDM Connector": [
      "manage_appointments",
      "register_patient",
      "care_context",
      "billing",
    ],

    "ABDM Connector/Adaptor - HIU/HIP": [...connector],
    "ABDM Connector/Adaptor - HIU": [...connector],
    "ABDM Connector/Adaptor - HIP": [],
    "Health Repository Provider (HRP) Service - HIU/HIP": [...both],
    "Health Repository Provider (HRP) Service - HIU": [...hiu],
    "Health Repository Provider (HRP) Service - HIP": [...hip],
  },
  user: {
    "EHR/HMIS Service With ABDM Connector - HIU/HIP": [
      "manage_appointments",
      "register_patient",
      "care_context",
      "billing",
      "upload_report",
      "scan_qr",
      "scan_share_records",
    ],
    "EHR/HMIS Service Without ABDM Connector": [
      "manage_appointments",
      "register_patient",
      "care_context",
      "billing",
    ],

    "ABDM Connector/Adaptor - HIU/HIP": [...connector],
    "ABDM Connector/Adaptor - HIU": [...connector],
    "ABDM Connector/Adaptor - HIP": [],
    "Health Repository Provider (HRP) Service - HIU/HIP": [...both],
    "Health Repository Provider (HRP) Service - HIU": [...hiu],
    "Health Repository Provider (HRP) Service - HIP": [...hip],
  },
  "lab user": ["register_patient", "laboratories"],
  "pharmacy user": ["register_patient", "manage_medicines"],
  doctor: ["view_appointment"],
};
